<template>
  <div class="coupon_page">
    <navbar title="優惠卷"></navbar>
    <div class="tabs_container">
      <div class="tab" v-for="(item, index) in tabs" :key="index">
        <button @click="changeTab(index)" :class="{
        button_selected: index === currentTab,
        button_unselected: index !== currentTab,
      }">
          {{ item }}
        </button>
      </div>
    </div>

    <!-- 可使用 -->
    <div class="coupons_container" v-if="currentTab == 0">
      <unusedCoupon v-for="(item, index) in memberCouponList" :key="index" :item="item" @useCoupon="useCoupon"
        @toPage="toUseCouponPage"></unusedCoupon>
    </div>

    <!-- 未使用 -->
    <div class="coupons_container" v-if="currentTab == 1">
      <usedCoupon :coupons="usedCoupons"></usedCoupon>
    </div>

    <QRCodePopup ref="QRCode" />
  </div>
</template>
<script>
// import claimableCoupon from "../components/coupon/claimableCoupon.vue";
import unusedCoupon from "@/components/coupon/unusedCoupon.vue";
import usedCoupon from "@/components/coupon/usedCoupon.vue";
import navbar from "@/components/general/navbar.vue"
import QRCodePopup from "@/components/QRCodePopup.vue";
import { mapGetters } from 'vuex'
export default {
  components: {
    navbar,
    // claimableCoupon,
    unusedCoupon,
    usedCoupon,
    QRCodePopup
  },
  data() {
    return {
      tabs: ["可使用", "已使用"],
      currentTab: 0,
      usedCoupons: [],
    };
  },
  computed: {
    storeCode() {
      return this.$store.getters['userData/storeCode'];
    },
    ...mapGetters('coupon', {
      memberCouponList: 'memberCouponList'
    }),
  },
  async mounted() {
    this.initialize();
  },
  methods: {
    async initialize() {
      try {
        await this.$store.dispatch('coupon/getMemberCoupons')
      } catch (e) {
        console.log(e)
      }
    },
    changeTab(index) {
      this.currentTab = index;
    },
    async useCoupon(id) {
      console.log("使用優惠卷 id", id);
      this.$refs.QRCode.show = true
    },
    async toUseCouponPage(id) {
      await this.$store.dispatch('coupon/getMemberCouponInfo', id)
      // 點擊使用優惠卷時，進入使用頁面
      this.$router.push({
        path: `/${this.storeCode}/coupon/use/${id}`,
      });
    },
  },
  beforeRouteEnter(to, from, next) {
    /*
      如果從使用 coupon 頁面返回 
      則將 currentTab 設為 1
    */
    if (from.params.method === "use") {
      next((vm) => {
        vm.currentTab = 0;
      });
    } else {
      next();
    }
  },
};
</script>
<style lang="scss">
.coupon_page {
  width: 100vw;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  background-color: #F0F0F0;

  h2 {
    font-family: PingFang SC;
    font-size: 26px;
    font-weight: 500;
    color: #FD5001;
  }
}

.tabs_container {
  width: 100vw;
  height: 50px;
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: space-around;
  box-shadow: 0px 4px 5px 0px rgba(112, 112, 112, 0.33);
  -webkit-box-shadow: 0px 4px 5px 0px rgba(112, 112, 112, 0.33);
  -moz-box-shadow: 0px 4px 5px 0px rgba(112, 112, 112, 0.33);
  margin-bottom: 2px;

  .tab {
    flex-grow: 1;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border-radius: 0;
  }

  .button_unselected {
    width: 100%;
    border: none;
    height: 100%;
    padding: 0 4px;
    text-align: center;
    font-family: Arial, Helvetica, sans-serif;
    font-size: 18px;
    font-weight: 600;
    color: #666666;
    background-color: #fff;
    border-bottom: 3px solid transparent;
    border-radius: 0;
  }

  .button_selected {
    width: 100%;
    border: none;
    height: 100%;
    padding: 0 4px;
    text-align: center;
    font-family: Arial, Helvetica, sans-serif;
    font-size: 18px;
    font-weight: 600;
    background-color: #fff;
    color: #FD5001;
    border-bottom: 3px solid #FD5001;
    border-radius: 0;
  }
}


.coupon {
  width: 100%;
  padding: 15px 2.5vw;
  height: 188px;
  background-color: #fff;
  border-bottom: dotted 1px #999999;
  margin-bottom: 10px;

  .claim_button {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 120px;
    height: 36px;
    background-color: #FBCB02;
    border-radius: 6px;
    border: none;
    color: #000;
    font-weight: 500;
    font-family: PingFang SC;
    font-size: 15px;
    flex-shrink: 0;
    margin-top: 5px;
  }

  .coupon_image {
    width: 120px;
    height: 100%;
    border-radius: 6px;
    flex-shrink: 0;

    img {
      width: 100%;
      height: 120px;
      border-radius: 6px;
      flex-shrink: 0;
    }
  }
}

.coupon_detail {
  flex-grow: 1;
  height: 100%;
  margin-left: 10px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;

  .coupon_title {
    font-family: PingFang SC;
    font-size: 18px;
    font-weight: 500;
    color: #000;
    margin: 0 0 8px;
  }

  .coupon_descrption {
    font-size: 16px;
    font-weight: 400;
    font-family: PingFang SC;
    color: #666666;
    width: 100%;
  }

  .event_duration {
    font-family: PingFang SC;
    font-size: 12px;
    white-space: nowrap;
    font-weight: 400;
    color: #666666;
    margin: 0;
  }

  .usage_duration {
    font-family: PingFang SC;
    font-size: 12px;
    font-weight: 400;
    color: #fa821b;
    margin: 0;
    width: 100%;
  }
}
</style>
